export default "__VITE_ASSET__435599d2__"